import { Tab, TabList as TabListBase } from '@headlessui/react'
import { c } from 'lib/component-utils'
import { DisplayExtractor, extract, KeyExtractor } from 'lib/type-utils'
import { Fragment } from 'react'

type Props<T> = {
  tabs: T[]
  tabKey?: KeyExtractor<T>
  display?: DisplayExtractor<T>
  className?: string
}

const TabList = <T,>({ tabs, tabKey, display, className }: Props<T>) => {
  return (
    <TabListBase
      as={'div'}
      className={c`inline-flex items-center shadow-inner-sm font-medium bg-gray-200/60 rounded-lg p-[2px] space-x-[2px] ${className}`}
    >
      {tabs.map((tab) => (
        <Tab as={Fragment} key={extract(tab, tabKey)}>
          {({ selected }) => (
            <div
              className={c`hide-separators relative first-of-type:before:hidden w-max before:absolute before:top-[calc((2*2px+7px)/2)] before:left-0 before:-translate-x-px before:w-px before:h-[calc(100%-2*2px-7px)] before:bg-gray-300 transition-colors duration-300 py-0.5 px-3 outline-none focus-visible:ring-2 focus-visible:ring-primary-500 hover:bg-gray-50 block cursor-pointer rounded-[7px] ${selected} text-black bg-white shadow-sm hover:bg-white | text-gray-500`}
            >
              {extract(tab, display)}
            </div>
          )}
        </Tab>
      ))}
    </TabListBase>
  )
}

export default TabList
